// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1453":"eef9e134","4053":"5e3fcbca"}[chunkId] || chunkId) + "." + {"1097":"ca3dddf9324bebb2","1453":"c65717d8e2898fa2","1480":"43814656684b8ca6","3248":"d63088c7a8cf3715","4053":"b7012329e5de62da"}[chunkId] + ".js";
};